import Swal from "sweetalert2";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import THBText from "thai-baht-text";
import "pdfmake/build/vfs_fonts";

import "../assets/css/bootstrap.css";
import "../assets/css/custom-style.css";
import "./global.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: {
    normal: "FCIconic-Light.ttf",
    bold: "FCIconic-Bold.ttf",
    italics: "FCIconic-Italic.ttf",
    bolditalics: "FCIconic-Italic.ttf",
  },
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew-Bold.ttf",
    italics: "THSarabunNew-Italic.ttf",
    bolditalics: "THSarabunNew-BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

const tokens = getStorage("token");

const success = (icon, title, detail) => {
  return Swal.fire({
    icon: icon ? icon : "success",
    title: title ? title : global[locale]["สำเร็จ"],
    text: detail ? detail : global[locale]["การทำรายการสำเร็จแล้ว"],
    confirmButtonText: global[locale]["ตกลง"],
  });
};
const success_url = (url, icon, title, detail) => {
  return Swal.fire({
    icon: icon ? icon : "success",
    title: title ? title : global[locale]["สำเร็จ"],
    text: detail ? detail : global[locale]["การทำรายการสำเร็จแล้ว"],
    confirmButtonText: global[locale]["ตกลง"],
  }).then(() => {
    window.location.href = url;
  });
};
const alert = (icon, title, detail) => {
  return Swal.fire({
    icon: icon ? icon : "warning",
    title: title ? title : global[locale]["แจ้งเตือน"],
    text: detail ? detail : "",
    confirmButtonText: global[locale]["ตกลง"],
  });
};
const alert_url = (url, icon, title, detail) => {
  return Swal.fire({
    icon: icon ? icon : "warning",
    title: title ? title : global[locale]["แจ้งเตือน"],
    text: detail ? detail : "",
    confirmButtonText: global[locale]["ตกลง"],
  }).then(() => {
    window.location.href = url;
  });
};
const Logout = async () => {
  removeStorage();
  window.location.href = "/login";
  // return Swal.fire({
  //   icon: "warning",
  //   title: "แจ้งเตือน",
  //   text: "ออกจากระบบ",
  //   confirmButtonText: "ตกลง",
  // }).then(async () => {
  //   window.location.href = "/login";
  // });
};
const NumberZero = (number, length) => {
  return length
    ? number.toString().padStart(length, "0")
    : number.toString().padStart(2, "0");
};
const format_date = (date, format, locale) => {
  let array_month = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];
  let array_full_month = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];
  if(!date){
    return "";
  }
  let new_date = new Date(date);
  let full_date = "-";
  let day = new_date.getDate();
  let month = new_date.getMonth();
  let year = new_date.getFullYear();
  let hour = new_date.getHours();
  let minute = new_date.getMinutes();
  let second = new_date.getSeconds();
  if (locale) {
    if (locale.toLowerCase() === "en") {
      array_month = [
        "Jan.",
        "Feb.",
        "Mar.",
        "Apr.",
        "May.",
        "Jun.",
        "Jul.",
        "Aug.",
        "Sep.",
        "Oct.",
        "Nov.",
        "Dec.",
      ];
      array_full_month = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      year =
        new_date.getFullYear() > 2100
          ? new_date.getFullYear() - 543
          : new_date.getFullYear();
    } else {
      year =
        new_date.getFullYear() > 2100
          ? new_date.getFullYear()
          : new_date.getFullYear() + 543;
    }
  } else {
    year =
      new_date.getFullYear() > 2100
        ? new_date.getFullYear()
        : new_date.getFullYear() + 543;
  }
  if (format) {
    if (format === "date") {
      return new_date.getTime();
    }
    if (format === "yyyy,mm,dd") {
      return new_date.getTime();
    }
    format = format.toLowerCase();
    // TIME
    if (format.includes("hh:mm:ss")) {
      format = format.replaceAll(
        "hh:mm:ss",
        NumberZero(hour) + ":" + NumberZero(minute) + ":" + NumberZero(second)
      );
    } else if (format.includes("hh:mm")) {
      format = format.replaceAll(
        "hh:mm",
        NumberZero(hour) + ":" + NumberZero(minute)
      );
    } else if (format.includes("hh")) {
      format = format.replaceAll("hh:mm", NumberZero(hour));
    } else if (format.includes("h:m:s")) {
      format = format.replaceAll("h:m:s", hour + ":" + minute + ":" + second);
    } else if (format.includes("h:m")) {
      format = format.replaceAll("h:m", hour + ":" + minute);
    }
    // DAY
    if (format.includes("dd")) {
      format = format.replaceAll("dd", NumberZero(day));
    } else {
      format = format.replaceAll("d", day);
    }
    // MONTH
    if (format.includes("mmmm")) {
      format = format.replaceAll("mmmm", array_full_month[month]);
    } else if (format.includes("mmm")) {
      format = format.replaceAll("mmm", array_month[month]);
    } else if (format.includes("mm")) {
      format = format.replaceAll("mm", NumberZero(month + 1));
    } else if (format.includes("m")) {
      format = format.replaceAll("m", month + 1);
    }
    // YEAR
    if (format.includes("yyyy")) {
      format = format.replaceAll("yyyy", NumberZero(year, 4));
    } else if (format.includes("yyy")) {
      format = format.replaceAll("yyy", year.toString().slice(-3));
    } else if (format.includes("yy")) {
      format = format.replaceAll("yy", year.toString().slice(-2));
    } else if (format.includes("y")) {
      format = format.replaceAll("y", year);
    }
    full_date = format;
  } else {
    full_date =
      NumberZero(day) + "/" + NumberZero(month + 1) + "/" + NumberZero(year, 4);
  }
  return full_date;
};
const toFixed = (number, size) => {
  if (number) {
    if (number === 0) {
      return "0.00";
    }
    if (size) {
      return number.toFixed(size).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } else {
      return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
  } else {
    return "0.00";
  }
};
function total(array, key) {
  if (key) {
    return array.reduce((a, b) => a + (b[key] || 0), 0);
  } else {
    return array.reduce((a, b) => a + b, 0);
  }
}
const validate = (state, validate) => {
  for (let v of validate) {
    if (
      state[v] === "" ||
      state[v] === null ||
      (state[v] && state[v].length === 0)
    ) {
      alert("warning", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน");
      return true;
    }
  }
  return false;
};

const select_height = 40;
const select_style = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    height: select_height,
    minHeight: select_height,
    padding: 0,
    border: 0,
    backgroundColor: state.isDisabled ? "#EDEDED" : "#00000000",
    boxShadow: "none",
  }),
  valueContainer: (baseStyles, state) => ({
    ...baseStyles,
    height: select_height,
    paddingTop: 0,
    paddingLeft: 12,
    paddingBottom: 0,
  }),
  input: (baseStyles, state) => ({
    ...baseStyles,
    height: select_height,
    minHeight: select_height,
    padding: 0,
    margin: 0,
  }),
};
const required = <span className="text-danger mx-1">*</span>;

const set_header = async (method_value, token, body) => {
  let requestOptions = {};
  if (token) {
    if (body) {
      requestOptions = {
        method: method_value,
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        cache: "no-cache",
        body: body,
      };
    } else {
      requestOptions = {
        method: method_value,
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        cache: "no-cache",
      };
    }
  } else {
    if (body) {
      requestOptions = {
        method: method_value,
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
        cache: "no-cache",
        body: body,
      };
    } else {
      requestOptions = {
        method: method_value,
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
        cache: "no-cache",
      };
    }
  }
  return requestOptions;
};

async function GET(token, url, body) {
  let promise = new Promise(async function (resolve, reject) {
    let header = await set_header("GET", token, null);
    let text_body = "";
    if (body) {
      let array_body = Object.entries(body);
      text_body += "?";
      for (let bd of array_body) {
        text_body += bd[0] + "=";
        text_body += bd[1] + "&";
      }
      text_body = text_body.slice(0, -1);
    }
    await fetch(global.api + url + text_body, header)
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
        } else {
          if (error_message(result) === "โทเค็นไม่ถูกต้อง") {
            removeStorage();
            alert_url("/", "warning", "แจ้งเตือน", error_message(result));
          } else {
            alert("warning", "แจ้งเตือน", error_message(result));
          }
          resolve({ status: false, message: error_message(result) });
        }
      })
      .catch((e) => {
        resolve({ status: false, message: "เกิดข้อผิดพลาด" });
      });
  });
  return promise;
}
async function POST(token, url, body) {
  let promise = new Promise(async function (resolve, reject) {
    let header = await set_header("POST", token, JSON.stringify(body));
    await fetch(global.api + url, header)
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
        } else {
          if (error_message(result) === "โทเค็นไม่ถูกต้อง") {
            removeStorage();
            alert_url("/", "warning", "แจ้งเตือน", error_message(result));
          } else {
            alert("warning", "แจ้งเตือน", error_message(result));
          }
          resolve({ status: false, message: error_message(result) });
        }
      })
      .catch((e) => {
        resolve({ status: false, message: "เกิดข้อผิดพลาด" });
      });
  });
  return promise;
}
async function PUT(token, url, body) {
  let promise = new Promise(async function (resolve, reject) {
    let header = await set_header("PUT", token, JSON.stringify(body));
    await fetch(global.api + url, header)
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
        } else {
          if (error_message(result) === "โทเค็นไม่ถูกต้อง") {
            removeStorage();
            alert_url("/", "warning", "แจ้งเตือน", error_message(result));
          } else {
            alert("warning", "แจ้งเตือน", error_message(result));
          }
          resolve({ status: false, message: error_message(result) });
        }
      })
      .catch((e) => {
        resolve({ status: false, message: "เกิดข้อผิดพลาด" });
      });
  });
  return promise;
}
async function DELETE(token, url, body) {
  let promise = new Promise(async function (resolve, reject) {
    let header = await set_header("DELETE", token, null);
    await fetch(global.api + url, header)
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
        } else {
          if (error_message(result) === "โทเค็นไม่ถูกต้อง") {
            removeStorage();
            alert_url("/", "warning", "แจ้งเตือน", error_message(result));
          } else {
            alert("warning", "แจ้งเตือน", error_message(result));
          }
          resolve({ status: false, message: error_message(result) });
        }
      })
      .catch((e) => {
        resolve({ status: false, message: "เกิดข้อผิดพลาด" });
      });
  });
  return promise;
}
function error_message(result) {
  let message = "";
  if (result.detail) {
    message = result.detail;
  } else if (result.data && !result.data.message) {
    message = result.data;
  } else if (result.data.message) {
    message = result.data.message;
  } else {
    message = result.message;
  }
  return message;
}
async function gen_password(length) {
  let result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
function float(num) {
  if (/^\d*\.?\d{0,2}$/.test(num)) {
    return true;
  }
  return false;
}
function validateEmail(email) {
  let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (regex.test(email)) {
    return true;
  }
  return false;
}
function validateTH(text) {
  let regex = /^[ก-๙\d]+$/;
  if (regex.test(text)) {
    return true;
  }
  return false;
}
function validateEN(text) {
  let regex = /^[A-Za-z\d]+$/;
  if (regex.test(text)) {
    return true;
  }
  return false;
}
function validateENNumber(text) {
  let regex = /^[A-Za-z0-9]+$/;
  if (regex.test(text)) {
    return true;
  }
  return false;
}
function removeStorage() {
  let locale = localStorage.getItem("locale")
    ? localStorage.getItem("locale")
    : "th";
  localStorage.clear();
  localStorage.setItem("locale", locale);
}
function getStorage(type) {
  let data = {
    token: localStorage.getItem("token"),
    user: JSON.parse(localStorage.getItem("user")),
    permission: JSON.parse(localStorage.getItem("permission")),
    cashier: localStorage.getItem("cashier"),
    "5f4dcc3b5aa765d61d8327deb882cf99": localStorage.getItem(
      "5f4dcc3b5aa765d61d8327deb882cf99"
    ),
    cashier_summary: localStorage.getItem("cashier_summary")
      ? JSON.parse(localStorage.getItem("cashier_summary"))
      : {
          rental_price: [0, 0, 0], //ค่าเช่า
          guarantee_amount: [0, 0, 0], //ค่าค้ำประกัน
          return_guarantee_amount: 0, //คืนค่าค้ำประกัน
          equipment_fee: [0, 0, 0], //ค่าอุปกรณ์
          delivery_price: [0, 0, 0], //ค่าขนส่ง
          fuel_cost: [0, 0, 0], //ค่าน้ำมัน
          damage_cost: [0, 0, 0], //ค่าเสียหาย
          service_charge: [0, 0, 0], //ค่าบริการรับส่ง
          other_expenses: [0, 0, 0], //ค่าอื่นๆ
          rental_price_overdue: [0, 0, 0], //ค่าเช่าเกินกำหนด
          scale_price: [0, 0, 0], //ค่าขยายสัญญา
          discount: 0, //ส่วนลด
          point: 0, //ใช้แต้ม
          wallet: 0, //ใช้เงินสะสม
          agent: [0, 0], //เบิกค่าแนะนำ
          total_pay: [0, 0, 0],

          income_money: 0,
        },
    data_rent: localStorage.getItem("data_rent")
      ? JSON.parse(localStorage.getItem("data_rent"))
      : [],
    total_rent: localStorage.getItem("total_rent")
      ? localStorage.getItem("total_rent")
      : 0,
  };
  return data[type];
}
function days_between(date1, date2, time1, time2) {
  if (!time1 || !time2) { 
    var ONE_DAY = 1000 * 60 * 60 * 24;
    var date1_ms = date1?new Date(date1).getTime():new Date();
    var date2_ms = date2?new Date(date2).getTime():new Date();
    var difference_ms = Math.abs(date1_ms - date2_ms);
    return Math.round(difference_ms / ONE_DAY);
  } else {
    let date1_ms = new Date(
      format_date(date1, "yyyy-mm-dd", "en") +
        "T" +
        (time1 + ":00").slice(0, 8) +
        "Z"
    );
    let date2_ms = new Date(
      format_date(date2, "yyyy-mm-dd", "en") +
        "T" +
        (time2 + ":00").slice(0, 8) +
        "Z"
    );
    var difference_ms = Math.abs(date2_ms - date1_ms);

    var days = Math.floor(difference_ms / (1000 * 60 * 60 * 24));
    difference_ms -= days * (1000 * 60 * 60 * 24);

    var hours = Math.floor(difference_ms / (1000 * 60 * 60));
    difference_ms -= hours * (1000 * 60 * 60);

    var minutes = Math.floor(difference_ms / (1000 * 60));
    difference_ms -= minutes * (1000 * 60);

    var seconds = Math.floor(difference_ms / 1000);

    // alert("danger",
    //   "ผิดพลาดอย่างร้ายแรง",
    //   "difference_ms:" + date1 + ",,,,,,,,,,,,,"
    // )
    return {
      day: days,
      hour: hours,
      minute: minutes,
      second: seconds,
    };
  }
}
function days_between_return_car(date1, date2, time1, time2) {
  if (!time1 || !time2) {
    var ONE_DAY = 1000 * 60 * 60 * 24;
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();
    var difference_ms = Math.abs(date1_ms - date2_ms);
    if (date2_ms > date1_ms) {
      if (Math.round(difference_ms / ONE_DAY) > 0) {
        return Math.round(difference_ms / ONE_DAY) * -1;
      } else if (Math.round(difference_ms / ONE_DAY) === 0) {
        return 0;
      } else {
        return Math.round(difference_ms / ONE_DAY);
      }
    } else {
      return Math.round(difference_ms / ONE_DAY);
    }
  } else {
    let date1_ms = new Date(
      format_date(date1, "yyyy-mm-dd", "en") +
        "T" +
        (time1 + ":00").slice(0, 8) +
        "Z"
    );
    let date2_ms = new Date(
      format_date(date2, "yyyy-mm-dd", "en") +
        "T" +
        (time2 + ":00").slice(0, 8) +
        "Z"
    );
    var difference_ms = Math.abs(date2_ms - date1_ms);

    var days = Math.floor(difference_ms / (1000 * 60 * 60 * 24));
    difference_ms -= days * (1000 * 60 * 60 * 24);

    var hours = Math.floor(difference_ms / (1000 * 60 * 60));
    difference_ms -= hours * (1000 * 60 * 60);

    var minutes = Math.floor(difference_ms / (1000 * 60));
    difference_ms -= minutes * (1000 * 60);

    var seconds = Math.floor(difference_ms / 1000);
    var time = {
      day: days,
      hour: hours,
      minute: minutes,
      // second: second
      type: date1_ms < date2_ms ? "ก่อนกำหนด" : "เกินกำหนด",
    };
    return time;
  }
}
 
class DatePickerTH extends Component {
  state = {
    value: "",
    default: new Date(),
    array_date: [],
    array_month: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
    array_year: [],
    showCalendar: false,
    min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
    max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
  };
  componentDidMount = () => {
    let year = [];
    for (let i = -100; i < 100; i++) {
      year.push(new Date().getFullYear() + i);
    }
    this.setState({ array_year: year });
    if (this.props.value) {
      this.setState({
        default: new Date(this.props.value),
        value: new Date(this.props.value),
      });
    }
    if (this.props.min) {
      this.setState({ min: new Date(this.props.min) });
    } else {
      this.setState({
        min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
      });
    }
    if (this.props.max) {
      this.setState({ max: new Date(this.props.max) });
    } else {
      this.setState({
        max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
      });
    }
    this.getDates();
  };
  componentWillReceiveProps = (props) => {
    if (props.min) {
      this.setState({ min: new Date(props.min) });
    } else {
      this.setState({
        min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
      });
    }
    if (props.max) {
      this.setState({ max: new Date(props.max) });
    } else {
      this.setState({
        max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
      });
    }
    if (props.value) {
      this.setState({ value: new Date(props.value) }); 
    } else {
      this.setState({ value: "" }); 
    }
  };
  onChangeDate = (option) => {
    if (option === "") {
      this.props.onChange("");
    } else {
      this.props.onChange(Number(option.getFullYear()) + "-" + ("0" + (Number(option.getMonth()) + 1)).slice(-2) + "-" + ("0" + option.getDate()).slice(-2));
    }
    this.setState({ value: option, showCalendar: false }); 
  };
  getDates = () => {
    let dates = [];
    let date = new Date(this.state.default.getFullYear(), this.state.default.getMonth(), 1); 
    for (let d = 0; d < new Date(date).getDay(); d++) {
      dates.push("");
    }
    while (date.getMonth() === this.state.default.getMonth()) {
      dates.push(new Date(date).getDate());
      date.setDate(date.getDate() + 1);
    }
    this.setState({ array_date: dates });
  };
  render() {
    return (
      <div
        style={{
          minHeight: 44,
          position: "relative",
          width: "100%",
          fontSize: "0.8rem",
        }}
      >
        {this.state.showCalendar && (
          <div
            style={{
              bottom: 0,
              left: 0,
              top: 0,
              right: 0,
              backgroundColor: "#0000",
              zIndex: 1000,
              position: "fixed",
            }}
            onClick={() => {
              this.setState({ showCalendar: false });
            }}
          ></div>
        )}
        <div style={{ width: "100%" }}>
          <input
            className={this.props.className}
            style={{ cursor: "pointer" }}
            type="text"
            value={this.state.value && typeof this.state.value === "object" ? ("0" + this.state.value.getDate()).slice(-2) + "/" + ("0" + (Number(this.state.value.getMonth()) + 1)).slice(-2) + "/" + (Number(this.state.value.getFullYear())) : this.state.value}
            placeholder={this.state.placeholder ? this.state.placeholder : "dd/mm/yyyy"}
            onFocus={() => {
              this.setState({
                showCalendar: true,
                default: this.state.value ? new Date(this.state.value) : new Date(),
              });
              setTimeout(() => {
                this.getDates();
                var offsets = document.getElementById("calendar");
                let box_left = offsets.getBoundingClientRect().left;
                let box_top = offsets.getBoundingClientRect().top;
                let width = window.innerWidth;
                let height = window.innerHeight;
                if (box_left + 300 > width) {
                  offsets.style.left = "-300px";
                }
                if (box_top + 335 > height) {
                  offsets.style.top = "-335px";
                }
                offsets.style.opacity = "1";
              }, 1);
            }}
            onChange={(e)=>{ 
              this.setState({value:e.target.value}) 
            }} 
            onKeyUp={(e)=>{ 
              if(e.key === "Enter"){
                e.target.blur();
              }
            }}
            onBlur={()=>{
              const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;  
              if (regex.test(this.state.value)) {
                this.setState({default:new Date(Number(this.state.value.split("/")[2])>2100?Number(this.state.value.split("/")[2])-543:Number(this.state.value.split("/")[2]),Number(this.state.value.split("/")[1])-1,Number(this.state.value.split("/")[0]))})
                setTimeout(() => {
                  this.onChangeDate(new Date(this.state.default.getFullYear(), this.state.default.getMonth(), this.state.default.getDate()));
                }, 10);
              }else if(typeof this.state.value === "object" && this.state.value !== "Invalid Date"){ 
              }else if(this.state.value.length === 8 && Number(this.state.value)){ 
                this.setState({default:new Date(Number(this.state.value.slice(-4))>2100?Number(this.state.value.slice(-4))-543:Number(this.state.value.slice(-4)),Number(this.state.value.slice(2,4))-1,Number(this.state.value.slice(0,2)))})
                setTimeout(() => {
                  this.onChangeDate(new Date(this.state.default.getFullYear(), this.state.default.getMonth(), this.state.default.getDate()));
                }, 10);
              }else{
                this.setState({value:""})
              }
              
            }}
            disabled={this.props.disabled}
            maxLength={10}
          />
          {this.state.showCalendar && (
            <div
              id="calendar"
              style={{
                opacity: 0,
                zIndex: 1001,
                width: 300,
                position: "absolute",
                marginTop: "0.3rem",
                paddingTop: "0.3rem",
                paddingBottom: "0.3rem",
                display: "flex",
                flexDirection: "column",
                minWidth: 0,
                wordWrap: "break-word",
                backgroundColor: "#ffffff",
                backgroundClip: "border-box",
                border: "1px solid rgba(0,0,0,.125)",
                borderRadius: 8,
                boxShadow: "0 0.3rem 1rem rgba(0, 0, 0, .15)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {this.state.default.getMonth() === 0 && this.state.default.getFullYear() === new Date().getFullYear() - 100 ? (
                  <span style={{ color: "#e1e2e2", padding: "1rem" }}>{"<"}</span>
                ) : (
                  <span
                    style={{ cursor: "pointer", padding: "1rem" }}
                    onClick={() => {
                      let date = this.state.default; 
                        date.setDate(1); 
                      date.setMonth(date.getMonth() - 1);
                      if( new Date(date).getTime() < new Date(this.props.min).getTime()){ 
                        date = this.props.min;
                      }
                      this.setState({ default: date });
                      setTimeout(() => {
                        this.getDates();
                      }, 1);
                    }}
                  >
                    {"<"}
                  </span>
                )}
                {/* เดือน */}
                <select
                  style={{ width: 100, borderWidth: 0, textAlign: "center" }}
                  onChange={(e) => {
                    let date = this.state.default;
                    date.setDate(1); 
                    date.setMonth(e.target.value);
                    if( new Date(date).getTime() < new Date(this.props.min).getTime()){
                      date = this.props.min;
                    }
                    if(new Date(this.props.max).getTime()< new Date(date).getTime()){
                      date = this.props.max;
                    }
                    this.setState({ default: date });
                    setTimeout(() => {
                      this.getDates();
                    }, 1);
                  }}
                  value={this.state.default ? this.state.default.getMonth() : ""}
                >
                  {this.state.array_month.map((item, index) => (
                    <option value={index}>{item}</option>
                  ))}
                </select>
                <label
                  style={{
                    marginLeft: "0.3rem",
                    marginRight: "0.3rem",
                    paddingBottom: 0,
                    cursor: "pointer",
                  }}
                >
                  พ.ศ.
                </label>
                {/* ปี */}
                <select
                  style={{ width: 60, borderWidth: 0, textAlign: "center" }}
                  onChange={(e) => {
                    let date = this.state.default;
                    date.setDate(1); 
                    date.setFullYear(e.target.value);
                    if( new Date(date).getTime() < new Date(this.props.min).getTime()){
                      date = this.props.min;
                    }
                    if(new Date(this.props.max).getTime()< new Date(date).getTime()){
                      date = this.props.max;
                    }
                    this.setState({ default: date });
                    setTimeout(() => {
                      this.getDates();
                    }, 1);
                  }}
                  value={this.state.default ? this.state.default.getFullYear() : ""}
                >
                  {this.state.array_year.map((item, index) => (
                    <option value={item}>{item+543} </option>
                  ))}
                </select>
                {this.state.default.getMonth() === 11 && this.state.default.getFullYear() === new Date().getFullYear() + 99 ? (
                  <span style={{ color: "#e1e2e2", padding: "1rem" }}>{">"}</span>
                ) : (
                  <span
                    style={{ cursor: "pointer", padding: "1rem" }}
                    onClick={() => {
                      let date = this.state.default; 
                      date.setDate(1); 
                      date.setMonth(date.getMonth() + 1);
                      if(new Date(this.props.max).getTime()< new Date(date).getTime()){
                        date = this.props.max;
                      }
                      this.setState({ default: date });
                      setTimeout(() => {
                        this.getDates();
                      }, 1);
                    }}
                  >
                    {">"}
                  </span>
                )}
              </div>
              <div
                style={{
                  marginBottom: "1rem",
                  marginLeft: 0,
                  marginRight: 0,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    width: "14.28%",
                    padding: "0,25rem 0",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  อา.{" "}
                </div>
                <div
                  style={{
                    width: "14.28%",
                    padding: "0,25rem 0",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  จ.{" "}
                </div>
                <div
                  style={{
                    width: "14.28%",
                    padding: "0,25rem 0",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  อ.{" "}
                </div>
                <div
                  style={{
                    width: "14.28%",
                    padding: "0,25rem 0",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  พ.{" "}
                </div>
                <div
                  style={{
                    width: "14.28%",
                    padding: "0,25rem 0",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  พฤ.{" "}
                </div>
                <div
                  style={{
                    width: "14.28%",
                    padding: "0,25rem 0",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  ศ.{" "}
                </div>
                <div
                  style={{
                    width: "14.28%",
                    padding: "0,25rem 0",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  ส.{" "}
                </div>
              </div>
              <div
                style={{
                  marginTop: "-1rem",
                  marginLeft: 0,
                  marginRight: 0,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  height: 220,
                }}
              >
                {this.state.array_date.map((item, index) => (
                  <div
                    style={
                      this.state.value &&  typeof this.state.value === "object" && item && this.state.value.getDate() === item && this.state.value.getMonth() === this.state.default.getMonth() && this.state.value.getFullYear() === this.state.default.getFullYear()
                        ? new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()
                          ? {
                              width: "14.28%",
                              paddingTop: "0.3rem",
                              paddingBottom: "0.3rem",
                              textAlign: "center",
                              cursor: "pointer",
                              backgroundColor: "#0d6efd",
                              color: "#ffffff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }
                          : {
                              width: "14.28%",
                              paddingTop: "0.3rem",
                              paddingBottom: "0.3rem",
                              textAlign: "center",
                              backgroundColor: "#0d6efd",
                              color: "#e1e2e2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }
                        : new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()
                        ? {
                            width: "14.28%",
                            paddingTop: "0.3rem",
                            paddingBottom: "0.3rem",
                            textAlign: "center",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }
                        : {
                            width: "14.28%",
                            paddingTop: "0.3rem",
                            paddingBottom: "0.3rem",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#e1e2e2",
                          }
                    }
                    onClick={() => {
                      if (new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()) {
                        this.onChangeDate(new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item));
                      }
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingLeft: "0.3rem",
                  paddingRight: "0.3rem",
                }}
              >
                {this.props.clearable !== false ? (
                  <label
                    style={{ cursor: "pointer", color: "#0d6efd" }}
                    onClick={() => {
                      this.onChangeDate("");
                    }}
                  >
                    clear
                  </label>
                ) : (
                  <label></label>
                )}
                <label
                  style={{ cursor: "pointer", color: "#0d6efd" }}
                  onClick={() => {
                    this.onChangeDate(new Date());
                  }}
                >
                  To day
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
async function getimgBase64(url) {
  try { 
    let promise = await new Promise(async function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve("data:image/png;base64," + reader.result.split(",")[1]);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send(); 
    });
    return promise;
  } catch (e) {
    return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAMSURBVHicY2BgYAAAAAQAAfYXOFUAAAAASUVORK5CYII=";
  }
}
async function print_paper01(item) {  
    var line = {
      layout: {
        hLineStyle: function (i, node) {
          return { dash: { length: 1, space: 1 } };
        },
        vLineStyle: function (i, node) {
          return { dash: { length: 1 } };
        },
      },
      margin: [0, 0, 0, 4],
    };
    var eq = item.equipment_list.map((e) => {
      return {
        text:
          e.equipment_name +
          " จํานวน " +
          e.equipment_qty +
          " ชิ้น เป็นเงินทั้งหมด " +
          e.equipment_price * e.equipment_qty +
          " บาท",
      };
    });
    var id = -1;
    var columns = [];
    var img = [];
    var index = 0;
    for (let e of item.detail_picture) {
      if (index % 3 === 0) {
        id = -1;
      }
      id += 1;
      img.push({
        image: e,
        fit: [175, 175],
        margin: [0, 0, 10, 0],
      });
      index += 1;
      if (id === 2) {
        columns.push({ columns: img });
        columns.push({ text: " " });
        img = [];
      }
    }
    if (img.length !== 0) {
      columns.push({ columns: img });
    }

    var docDefinition = {
      content: [
        {
          columns: [
            { text: " ", width: "*" },
            {
              columns: [
                {
                  width: 50,
                  image:
                    "data:image/png;base64,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",
                },
                {
                  width: 190,
                  stack: [
                    {
                      text: "S.K.Service Motorcycle For Rent",
                      bold: true,
                      alignment: "center",
                    },
                    {
                      text: "098-7532665 , 089-5580007",
                      bold: true,
                      alignment: "center",
                    },
                  ],
                },
              ],
              width: 240,
            },
            { text: " ", width: "*" },
          ],
        },
        " ",
        { text: "(สัญญาเช่า รถจักรยานยนต์)", alignment: "center" },
        {
          columns: [
            {
              text: "This contract has been Made in Chiang Mai สัญญานี้ทําขึ้นที่จังหวัดเชียงใหม่",
              alignment: "left",
            },
            {
              text: "Date/วันที่ " + format_date(new Date(), "dd/mm/yyyy"),
              alignment: "right",
            },
          ],
        },
        "Between S.K.Service In contract will be called “Lessor / ระหว่าง S.K.Service ซึ่งจะเรียกว่าผู้ให้เช่า",
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "And",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.full_name ? item.full_name : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "in contract will be called “Lessee” ซึ่งจะเรียกว่าผู้เช่า",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        " ",
        { text: "Lessee Details (รายละเอียดของผู้เช่า)", bold: true },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: [
              [
                {
                  text: "Date of birth /วันเดือนปีเกิด",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.birthday
                    ? format_date(item.birthday, "dd/mm/yyyy")
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Nationality สัญชาติ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.nationality ? item.nationality : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Issued by /ออกโดย",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.card_issue ? item.card_issue : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Passport No/หมายเลขบัตรประชาชน",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.id_card ? item.id_card : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: [
              [
                {
                  text: "Issued date/วันที่ออก ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.date_issue
                    ? format_date(item.date_issue, "dd mmmm yyyy")
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Expire date/วันหมดอายุ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.date_expire
                    ? format_date(item.date_expire, "dd mmmm yyyy")
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Address/ที่อยู่ตามบัตรประชาชน",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text:
                    (item.address ? item.address : "") +
                    (item.sub_district ? " ต." + item.sub_district : "") +
                    (item.district ? " อ." + item.district : "") +
                    (item.province ? " จ." + item.province : "") +
                    (item.zip_code ? " " + item.zip_code : ""),
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Address in Thailand/ที่พักหรือโรงแรมที่ติดต่อได้",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.temporary_accommodation
                    ? item.temporary_accommodation
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Pick up location/สถานที่รับรถ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.pick_up_location ? item.pick_up_location : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Returning location/สถานที่คืนรถ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.return_location ? item.return_location : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Telephone Number",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.phone ? item.phone : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        " ",
        { text: "Bike Details (รายละเอียด รถ)", bold: true },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: [
              [
                {
                  text: "Type/ชนิด/รุ่น",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.selected_bike.brand_name
                    ? item.selected_bike.brand_name
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Plate No/ทะเบียน",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.selected_bike.license_plate
                    ? item.selected_bike.license_plate
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: [
              [
                {
                  text: "Color/สี",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.selected_bike.bike_color
                    ? item.selected_bike.bike_color
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Mileage/จํานวนไมล์",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.mileage ? item.mileage : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*", "auto"],
            body: [
              [
                {
                  text: "Channel No/หมายเลขรถ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.selected_bike.bike_channel_name
                    ? item.selected_bike.bike_channel_name
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Oil level ระดับน้ำมัน",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.oil_volume ? item.oil_volume : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "%",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        " ",
        { text: "Condition (สภาพ)", bold: true },
        ...columns,
        " ",
        { text: "Equipments (อุปกรณ์)", bold: true },
        { ol: eq },
        " ",
        { text: "Renting Conditions ลักษณะการให้เช่า", bold: true },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "From Departure Date/วันที่ออกเดินทาง",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.pick_up_date
                    ? format_date(item.pick_up_date, "dd mmmm yyyy") +
                      " " +
                      item.pick_up_time.slice(0, 5)
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "o'clock/น.",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "To Return Date/วันที่กลับ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.return_date
                    ? format_date(item.return_date, "dd mmmm yyyy") +
                      " " +
                      item.return_time.slice(0, 5)
                    : "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "o'clock/น.",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Note",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.guarantee_type.label +(item.guarantee_money?" ( "+item.guarantee_money+" ) ":"")+(item.guarantee_amount?" ( "+item.guarantee_amount+" บาท ) ":""),
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*", "auto", "*", "auto"],
            body: [
              [
                {
                  text: "Total time/ระยะเวลา",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: Math.round(item.days.day / 30),
                  lineHeight: 0.7,
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: "month/เดือน",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.days.day % 30,
                  lineHeight: 0.7,
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: "Days/วัน",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.days.hour,
                  lineHeight: 0.7,
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: "Hour/ชั่วโมง",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        " ",
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "Renting Rate/อัตราค่าเช่า",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.selected_bike
                    ? toFixed(item.selected_bike.daily_price)
                    : "0.00",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Baht บาท",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "Total Renting/รวมค่าเช่า",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.rental_price ? toFixed(item.rental_price) : "0.00",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Baht บาท",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "Other อื่น ๆ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Baht บาท",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "Discount ส่วนลด",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.discount_price
                    ? toFixed(item.discount_price)
                    : "0.00",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Baht บาท",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "Pick-up Service/ค่าบริการรับ-ส่ง",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.delivery_price
                    ? toFixed(item.delivery_price)
                    : "0.00",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Baht บาท",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "Booking/จอง",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.overdue_booking
                    ? toFixed(item.overdue_booking)
                    : "0.00",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Baht บาท",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "Security Deposit เงินประกันความเสียหาย",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.guarantee_amount
                    ? toFixed(item.guarantee_amount)
                    : "0.00",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Baht บาท",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto"],
            body: [
              [
                {
                  text: "Total Amount/รวมเป็นเงิน",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.total_price ? toFixed(item.total_price) : "0.00",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "Baht บาท",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
          ...line,
        },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "payment status/สถานะการชําระเงิน ",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.rental_status === 2 ?"ค้างชำระ":"ชำระแล้ว",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
          ...line,
        },
        " ",
        { text: "CONTRACT DETAILS (RESUME) รายละเอียด สัญญา", bold: true },
        "1. The Lessee must provide a valid passport and a valid motorbikes driving license ผู้เช่าจะต้องแสดงหนังสือเดินทางที่ ถูกต้องและใบอนุญาตขับรถ รถมอเตอร์ไซด์ที่ถูกต้อง",
        "2. The deposit and the rental fee must be fully paid by cash the first hiring day. การชําระเงิน อัตราค่าเช่าจะต้องชําระ เงินเต็มจํานวนด้วยเงินสด ในวันเช่ารถครั้งแรก",
        "3. Lennee's passport and deposit are held during the rental period. หนังสือเดินทางของผู้เช่าและเงินมัดจําทางผู้ให้เช่าจะ เก็บไว้ในช่วงระยะเวลาการเช่า",
        "4. In case of accident. The essere will have to pay for the whole bike damages. ในกรณีที่เกิดอุบัติเหตุผู้เช่าจะต้องจ่าย สําหรับการเกิดความเสีย หายในส่วนต่างๆ ของรถจักรยานยนต์ทั้งหมด",
        "5. The Lessee shall hire the vehicle for him/her and cannot borrow the bike to another person. The Lessee is the only person covered by the insurance. Sub-hiring the Bikes to a third party is totally prohibited. ผู้เช่าจะต้องใช้รถ สําหรับตัวเองและไม่สามารถให้ผู้อื่นยืมรถจักรยานยนต์ไปใช้ ผู้เช่าเป็นเพียงคนเดียวที่ครอบครองรถ โดยต้องรับประกัน ว่าไม่เช่าไปให้ บุคคลที่สามแต่อย่างใด",
        "6. The Lesson must take good care and maintained the bike as his own property. ผู้เช่าจะต้องดูแลรักษารถจักรยานยนต์ เป็นอย่างดีเปรียบ เสมือนทรัพย์สินของตัวท่านเอง",
        "7. The Lessee will not be rotuned deposit in case of early return. ผู้เช่าจะไม่ได้รับเงินค่าเช่าคืนในกรณีที่ส่งคืนรถก่อน กําหนดเวลา",
        "8. In any case of accident and what ever happened to the lessee, the bike or any third party, the lessee agrees to never engage S.K. Service for rent and/or the bike's owner, own responsibility. ในกรณีที่เกิดอุบัติเหตุและสิ่งที่เคยเกิดขึ้น กับผู้เช่ารถจักรยานยนต์หรือบุคคลที่สามไม่ว่ากรณีใด ๆ ผู้เช่าตกลงที่จะรับผิดชอบโดยไม่เกี่ยวกับ S.K. Service และ / หรือเจ้าของของ จักรยานยนต์ ในความรับผิดชอบของตัวเอง",
        "9. If the Lessee is breach of contract in any section. The Lessor reserves the right to terminate this contract immediately without any prior notification, and reserves to claim the charge in full amount. Any controversy of this contract, shall be proceed an action according to law. หากผู้เช่ามีการละเมิดสัญญาในส่วนใด ส่วนหนึ่ง ผู้ให้เช่าขอสงวนสิทธิ์ที่ จะบอกเลิกสัญญานี้ได้ทันทีโดยไม่ต้องแจ้งให้ทราบล่วงหน้าและมีสิทธิ์ที่ จะเรียกร้อง ค่าใช้จ่ายในเงินเต็มจํานวน ตามความขัดแย้งของ สัญญาใด ๆ นี้และจะถูกดําเนินการตามกฎหมาย",
        "10. More details can be found in the General rental conditions section. รายละเอียดเพิ่มเติมสามารถเพิ่มเติมได้ในส่วนของ เงื่อนไขการเช่า",
        "I have read and I agree with the whole contract terms and conditions and I hereby acknowledge my liability under the road traffic, as set out in clauses.",
        "ข้าพเจ้าได้อ่านและตกลงตามข้อสัญญาทุกเงื่อนไขและข้าพเจ้ารับทราบถึงความรับผิดของข้าพเจ้า ภายใต้การจราจรบนถนนในขณะใช้รถ ตามที่กําหนดไว้ในข้อตกลง",
        " ",
        {
          table: {
            headerRows: 1,
            widths: [45, "*", 100, 45, "*", 65],
            body: [
              [
                {
                  text: "ลงชื่อ/Sign",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: item.created_by
                    ? item.created_by
                    : getStorage("user").full_name,
                  lineHeight: 0.7,
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: "ผู้ให้เช่า/Lessor's",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: "ลงชื่อ/Sign",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: " ",
                  lineHeight: 0.7,
                  alignment: "left",
                  border: [false, false, false, true],
                },
                {
                  text: "ผู้เช่า/Lessee's",
                  lineHeight: 0.7,
                  margin: [-4, 0, 0, 0],
                  border: [false, false, false, false],
                },
              ],
              [
                { text: " ", colSpan: 6, border: [false, false, false, true] },
                "",
                "",
                "",
                "",
                "",
              ],
            ],
          },
          ...line,
        },
        { image: "signature", width: 100, margin: [380, -70, 0, 30] },
        " ",
        { text: "General rental conditions (เงื่อนไขการเช่าทั่วไป)", bold: true },
        "In this contract the Lessor is the owner of the vehicle. The Lessee is the person who signs the contract to rent and use the vehicle, described in the clauses and conditions of the contract, which he accepts and agrees to respect. ในสัญญานี้ผู้ให้เช่าเป็นเจ้าของของยานพาหนะ ผู้เช่าเป็นคนที่เซ็นสัญญาเช่าและ ใช้ยานพาหนะที่อธิบายไว้ในส่วนของข้อตกลงและ เงื่อนไขของสัญญาซึ่งเขายอมรับและตกลงที่ปฏิบัติตามเงื่อนไขอย่างเคร่งครัด ",
        {
          text: "Article 1 - VEHICLE USE and EXCLUSION from the INSURANCE ข้อ 1 - การใช้รถและการยกเว้นจากการรับประกันภัย",
          bold: true,
        },
        "The none respect of anyone of the obligations described below will lead to the loss of the insurance coverage. The Lessee agrees to not allow any other person than the one accredited by the Lessor to drive the vehicles. หากไม่ ปฏิบัติตามข้อตกลงที่อธิบายไว้ด้านล่างจะนําไปสู่การสูญเสียของประกัน ผู้เช่า ตกลงที่จะไม่อนุญาตให้บุคคลอื่นใดมากกว่าหนึ่ง ได้รับการ รับรองโดยผู้ให้เช่าการขับรถ ",
        "The Lessee also agrees for the vehicle met to be used : ผู้เช่ายังตกลงที่จะไม่ใช้ยานพาหนะดังนี้ : ",
        "a) For competitions and driving test, even on a closed circuit, except in case of agreement by the Lessor สําหรับการ แข่งขันและการทดสอบการขับขี่แม้ ในวงจรปิดยกเว้นในกรณีของที่ได้ตกลงกับผู้ให้เช่า ",
        "b) By a person under alcohol or druge influence, or any substances that can affect the driving abilities of the driver, even for himself in that hypothesis. ห้ามบุคคลที่ดื่มเครื่องดื่มแอลกอฮอล์หรือเสพยาเสพติดที่มีอิทธิพลต่อหรือสารใด ๆ ที่สามารถ ส่งผลกระทบต่อความสามารถในการขับขี่ ของคนขับแม้สําหรับ ตัวเองในสมมติฐานที่ว่า ขับขี่ยวดยานพาหนะ",
        "c) For illegal stuff or any goods transportation or persons transportation for business ห้ามใช้สําหรับสิ่งที่ผิดกฎหมายหรือ การขนส่งสินค้าหรือการขนส่งบุคคลสําหรับธุรกิจ ",
        "d) In overcharge when transporting more than 2 people (Driver included), ในบรรทุกมากเกินไปเมื่อท่าการขนส่งมากกว่า 2 คน รวมผู้ขับขี่ ",
        "e) By not allowed people in the contract terms or without a Lessor agreement, ห้ามคนไม่ได้รับอนุญาตในเงื่อนไขของ สัญญาหรือผู้ให้เช่าโดยไม่มีข้อตกลง",
        "f) The Lessee also commits to: ข้อตกลงของผู้เช่า ",
        "Keep the vehicle protected against thief with a lock, when the vehicle is not in use, and keeping the keys in its possession. เก็บรถป้องกันขโมยโดยใช้ระบบล็อก เมื่อรถไม่ได้อยู่ในการใช้งานและการเก็บรักษากุญแจต้องอยู่ในความครอบครองของตน",
        "Get back the vehicle keys and papers to the Lessor. If the Lessee does not respect this engagement and if the vehicle is stolen, the liability of the Lessee will be engaged. The Lessee will also be in charge of all the costs due to this breach (Making new keys fines etc.) การคืนกุญแจรถและเอกสาร แก่ผู้ให้เช่า หากผู้เช่าไม่เคารพตามข้อตกลงและถ้ากุญแจ รถหาย ผู้เช่าจะต้องรับผิดชอบในค่าใช้จ่ายทั้งหมด (ต้องจ่ายค่าปรับในการทํากุญแจใหม่, ) ",
        "Never transfer thin contract, neither sell nor mortgage the vehicle or its equipment. ไม่โอนสัญญานี้ไม่ขายหรือจํานองยาน พาหนะหรืออุปกรณ์ ",
        "Any Violation to any of these engagements allows the Lessor to ask for the restitution of the vehicle without any delay. การละเมิดใด ๆ ของข้อตกลง เหล่านี้ ให้ผู้ให้เช่าสามารถเรียกร้องให้ชดใช้ความเสียหายของรถได้ทันที",
        {
          text: "Article 2 - VEHICLE CONDITION ข้อ 2 - เงื่อนไขยานพาหนะ",
          bold: true,
        },
        "The Lessee agrees to have received the vehicle in good working and cleanliness conditions. The tires are in good condition without any scare. If tires are damaged, the Lessee agrees to cover for new tires with same dimensions and same wear. The lessee is responsible for other damages than the normal wear and tear. The lessor reserves the right to have the lessee pay for one month rental rate if the bike is damaged beyond ride ability. This means the bike cannot be rented until repairs have been made. Once repairs have been made and if done before the month has ended. The remainder of the deposit will be returned to the leasee. ผู้เช่าตกลง และจะได้รับรถในสภาพที่พร้อมการ ใช้งานได้ดี สะอาด และยางอยู่ในสภาพดี ถ้ายางมีความเสียหายผู้เช่าตกลงที่จะ เปลี่ยน ยางใหม่ที่มี ขนาดเดียวกันให้แทนยางเดิม ผู้เช่า เป็นผู้รับผิดชอบต่อความเสียหายอื่น ๆ ทั่วไป ไม่ว่าจะเป็นการฉีกขาดและการสึกหรอ ",
        {
          text: "Article 3 - RENTAL-PAYMENT-EXTRA TIME ข้อ 3 ระยะ เวลาเช่า และการชําระเงิน",
          bold: true,
        },
        "The applicable rental rates are the one in use when the contract is signed. The rental fee is due as a whole when the contract is Signed. If the Lessee wants to keep the vehicle for a longer period than it was planed, he must inform the Lessor and obtain his Agreement timing. The Lessee agrees to bring back the vehicle at the exact agreed date into the contract. The Lessee agrees to precise his exact and complete home address at the beginning of the rental period. อัตราค่าเช่าใช้เป็นส่วนหนึ่งในการทําสัญญาที่มีการลงนามกําหนด คําเช่าโดยรวมเมื่อทําสัญญาลงนาม หากผู้เช่าต้องการ ที่จะครอบครอง ยานพาหนะ เป็นระยะเวลานานกว่าที่มันจะกําหนดไว้ ท่านจะต้องแจ้งให้ผู้ให้เช่าทราบ และต้องกําหนดระยะเวลาลงใน ข้อสัญญา ผู้เช่าตกลงที่จะนํารถกลับมาตื่นให้ตรงกับวันที่ตกลงไว้ในสัญญา ผู้เช่ายอมรับข้อตกลงและ ให้ที่อยู่บ้านที่ถูกต้องและสมบูรณ์ ตั้งแต่เริ่มเช่า",
        { text: "Article 4 - PAYMENTS ข้อ 4 การชําระเงิน", bold: true },
        "The person mentioned in the contract is in charge of all rental, extra and damages fees, In case of theft or damages on the vehicle the Lessee is responsible for paying all the damages made on the vehicle and its equipments and accessories during the rental period. If the damages cost, after indemnification of a liable third party, if existing, is under the deposit, the deposit will provide the payment. If not, the Lessee will be in charge near",
        "กล่าวถึงในสัญญาเป็นผู้รับผิดชอบในค่าเช่า ค่าใช้จ่ายเพิ่มเติมและความเสียหาย ในกรณีที่ถูกขโมยหรือความเสียหายบนยานพาหนะ ผู้เช่าเป็นผู้รับผิดชอบในการจ่ายค่าเสีย หายทั้งหมดที่เกิดขึ้นกับยานพาหนะและอุปกรณ์และอุปกรณ์เสริมในระหว่างระยะเวลาการเช่า หากมีค่าใช้จ่ายความเสียหายหลังจากการชดใช้ค่าเสียหายของบุคคลที่สามได้ รับเงินไม่ครบ ผู้เช่าจะเป็นผู้รับผิดชอบในการจ่ายเงินที่ยัง ไม่ได้รับทั้งหมด",
        {
          text: "Article 5 - INSURANCES (COVER-EXCLUSIONS) ข้อ 5 การประกัน (ข้อยกเว้น)",
          bold: true,
        },
        "1. The Lessee and all allowed drivers, as defined higher up in the contract, are covered by an insurance policy for 2 wheeled motorcycles. This policy covers damages to a third party as defined in the law. ผู้เช่าและผู้ขับขี่ ยอมรับข้อตกลง ตามที่กําหนดไว้ ในการทําสัญญาจะครอบคลุมโดยนโยบายการประกันสําหรับ รถจักรยานยนต์ 25 นโยบายนี้ครอบคลุมถึงความเสียหาย ต่อบุคคลที่สามตามที่กําหนดไว้ตามกฎหมาย",
        "2. The Lessee agrees by this contract to this policy and agrees to respect its clauses and conditions. The lessee also agrees to make his best effort to protect the Lessor interest in case of accident during the rental period and in particular : ผู้เช่าตกลงตามสัญญานี้และตกลงที่จะเคารพคําสั่งและเงื่อนไข ผู้เช่ายัง ตกลงที่จะทําให้ดีที่สุดที่จะปกป้องผลประโยชน์ผู้ให้ เช่าในกรณีที่ เกิดอุบัติเหตุในช่วงระยะเวลาการเช่า",
        "To declare to the Lessor, as soon as possible, any accident, theft or incident, even partial. แจ้งให้ผู้ให้เช่าทราบโดยเร็ว ที่สุด ในกรณีที่เกิดประสบอุบัติเหตุใด หรือการโจรกรรมหรือเหตุการณ์ใดๆที่เกิดขึ้น",
        "To mention all the circumstances, date and location of the accident. To keep the numbers and address of the witnesses, the name and address of the owner of the opposite vehicle, the plate number, the name and number of insurance of the third party. แจ้งเหตุการณ์ทั้งหมดทั้ง วันที่และสถานที่ของการเกิด อุบัติเหตุ เพื่อให้ตัวเลขและที่อยู่ของพยาน แจ้งชื่อและที่อยู่ของเจ้าของรถตรง หมายเลขทะเบียน ชื่อ และจํานวนของการประกันของบุคคลที่สาม",
        "To join any police report if any. แจ้งรายละเอียดกับเจ้าหน้าที่ตํารวจ",
        "To not deal with the third party about the damages relative to the accident or its consequences. หากไม่ต้องการรับมือ กับบุคคลที่สามเกี่ยวกับค่าเสียหายเกิดกับ ผู้ประสบอุบัติเหตุหรือผลที่ตามมา",
        "1. The vehicle is only insured for the rental period indicated in the contract. If the extra period does not have the Lessor agreement, the Lessor will not cover any of the accident caused by the Lessee, The Lessee will be in charge personally. มีประกันภัยเฉพาะสําหรับระยะเวลาการเช่าที่ระบุไว้ในสัญญา ถ้าระยะ เวลาพิเศษไม่ได้มีข้อตกลงให้เช่า, ผู้ให้เช่าจะไม่ ครอบคลุมใด ๆ ของการเกิดอุบัติเหตุที่เกิดจากผู้เช่า ผู้เช่าจะต้องเป็นผู้รับผิดชอบเอง",
        "2. The liability of the Lessor won't be engaged in any case, for any goods forgotten by the lessee into the vehicle. ผู้ให้เช่าจะไม่มีส่วนร่วมในการรับผิดชอบ ในกรณีใด ๆ ที่ผู้เช่าลืมของไว้ในรถ",
        "3. in any case, the Lessee must take care of the vehicle and avoid all shocks. All noticed damages will be charged to the Lessee. ในกรณีใด ๆ ผู้เช่าจะ ต้องดูแลยานพาหนะและหลีกเลี่ยงการเกิดความเสียหาย ทั้งหมดหากเกิดความเสียหายผู้ให้เช่า จะเรียกค่าเสียหาย จากผู้เช่า",
        "4. The Lessor declines all liability for accidents to a third party or damages on the vehicle caused by the Lessee during the rental period, if the Lessee has provided forged information concerning his identify, and /or address and/or driving license validity. In that case, the Lessee will not be covered by the insurance policy.",
        "ผู้ให้เช่าปฏิเสธความรับผิดชอบสําหรับอุบัติเหตุทั้งหมดต่อบุคคลที่สาม หรือความเสียหายบนยานพาหนะที่เกิดจากผู้เช่าในช่วงระยะเวลา การเช่าถ้าผู้เช่าได้ให้ข้อมูลเกี่ยวกับการปลอมแปลงของเขาระบุและ / หรือที่อยู่และ / หรือใบอนุญาตขับรถถูกต้องตามกฎหมาย ในกรณี ที่ผู้เช่าจะไม่ครอบคลุมโดยนโยบายการประกัน",
        {
          text: "Article 6 - MAINTAINING and REPAIRING ข้อ 6 การบํารุงรักษาและการซ่อมแซม",
          bold: true,
        },
        "The normal wear and tear is taken into account by the Lessor. If the Lessee has to make any repair or maintenance during the rental Period, he will need the Lessor agreement first and then to provide detailed invoices for all the work done on the vehicle and spare parts used. การฉีกขาดปกติและการ สึกหรอจะอยู่ค่าใช้จ่ายโดยผู้ให้เช่า หากผู้เช่ามีการ ซ่อมแซมใด ๆ หรือการบํารุงรักษาในระหว่างการเช่า ตาม ระยะเวลาที่เขาจะต้องทําข้อตกลงให้เช่าครั้งแรกแล้ว ที่จะให้รายละเอียด สําหรับ ใบแจ้งหนี้ ในการซ่อมแซมยานพาหนะและอะไหล่ ที่ใช้",
        {
          text: "Article 7 - FUEL and OIL ข้อ 7 เชื้อเพลิงและน้ํามัน",
          bold: true,
        },
        "The fuel is in charge of the Lessee. The Lessor will provide a full tank; the Lessee agrees to bring the vehicle with full tank. If The vehicle is brought back without full tank, the Lessee will be charged for the missing fuel. 100 Baht will be charged for each missing stick of the fuel gauge. The Lessee must verify permanently the oil and the cooling system levels. If he has to refill it, he will have to provide invoices to be paid off. In the absence of that verification, the Lessee will have to pay for the engine repair. น้ํามันเชื้อเพลิงที่อยู่ในความดูแลของผู้เช่า ผู้ให้เช่าจะให้เต็มถัง ผู้เช่าตกลงที่จะ นํารถด้วยน้ํามันเต็มถัง ถ้ารถจะถูกนํากลับมาไม่เต็มถัง ผู้เช่าจะต้องจ่ายค่าน้ํามันเชื้อเพลิง สําหรับที่ขาดหายไป 100 บาทจะได้รับการเรียก เก็บเงินสําหรับส่วนที่ขาดหายไปของแต่ละมาตรวัด น้ํามันเชื้อเพลิง ผู้เช่าต้องตรวจสอบตลอดทั้งน้ํามันและระบบระบายความร้อนในระดับ พอดี ถ้ามีการเติมต้องให้ใบแจ้งหนี้ที่จะต้องจ่าย ออกไป ในกรณีที่ไม่มีการตรวจสอบดังกล่าว ผู้เช่าจะต้องจ่ายสําหรับการซ่อมแซม เครื่องยนต์",
        { text: "Article 8 - LIABILITIES ข้อ 8 หนี้สิน", bold: true },
        "The Lessee or the agreed drivers are criminally liable for breach of the law while driving the vehicle. The Lessee allows the Lessor to provide its identity to the police services in case of requisitioning. The rented vehicles can only be used in the territory of Thailand. The use of the vehicle outside the territory of Thailand will not be covered by the insurance policy. ผู้เช่าหรือตกลงเป็นความผิดทางอาญาต่อการละเมิดกฎหมายที่พวกเขาไม่ขับขี่ยานพาหนะ ผู้เช่าผู้ให้เช่าจะต้อง ให้ความร่วมมือกับตํารวจ ในกรณีของการเรียกร้อง ยานพาหนะให้เช่าสามารถจะใช้เพียงในอาณาเขตของประเทศไทย ใช้ยานพาหนะ นอกอาณาเขตของประเทศไทย จะไม่ได้รับการคุ้มครองจากกรมธรรม์ประกันภัย",
        {
          text: "Article 9 - CONTRACT VALIDITY ข้อ 9 ข้อตกลงล่วงหน้า",
          bold: true,
        },
        "Any modifications to the clauses and conditions of this contract if they are not notified by writing and granted by the Lessor will be null and void. การเปลี่ยนแปลงใด ๆ ในข้อตกลงและเงื่อนไขของสัญญานี้หากไม่ได้รับการแจ้งเตือนโดยการเขียน และหรือตกลงจากผู้ให้เช่าจะถือเป็น โมฆะ",
      ],
      images: {
        signature : item.signature
      },
      // , alignment: "justify"
      defaultStyle: {
        font: "THSarabunNew",
        fontSize: 16,
        lineHeight: 1,
        alignment: "justify",
      },
      pageSize: "A4",
      pageMargins: [15, 15, 15, 15],
      pageOrientation: "portrait",
    };  
      if (window.location.href.includes(":300")) {
        pdfMake.createPdf(docDefinition).open();
      } else {
        pdfMake.createPdf(docDefinition).download();
      }   
} 

async function print_receipt(item) {
  let equipment = 0;
  if (item.equipment_list) {
    for (let e of item.equipment_list) {
      equipment = e.equipment_price * e.equipment_qty;
    }
  }
  let receipt = [];
  if (item.admin_remark === "แคชเชียร์ ยืนยันการคืนรถ") {
    receipt = [
      [
        { text: "1", alignment: "center" },
        "ค่าเกินเวลา",
        { text: toFixed(item.rental_price_overdue), alignment: "right" },
      ],
      [
        { text: "2", alignment: "center" },
        "ค่าบริการรับ-ส่ง",
        {
          text: toFixed(item.service_charge - item.service_charge_pay),
          alignment: "right",
        },
      ],
      [
        { text: "3", alignment: "center" },
        "ค่าน้ำมัน",
        { text: toFixed(item.fuel_cost), alignment: "right" },
      ],
      [
        { text: "4", alignment: "center" },
        "ค่าปรับรถเสียหาย",
        { text: toFixed(item.damage_cost), alignment: "right" },
      ],
      [
        { text: "5", alignment: "center" },
        "ค่าอื่นๆ",
        {
          text: item.other_expenses ? toFixed(item.other_expenses) : "0.00",
          alignment: "right",
        },
      ],
      [
        { text: "6", alignment: "center" },
        "ค่าเปลี่ยนสถานที่/รถ",
        {
          text: item.service_charge_pay
            ? toFixed(item.service_charge_pay)
            : "0.00",
          alignment: "right",
        },
      ],
      [
        { text: "7", alignment: "center" },
        "ส่วนลด",
        {
          text: item.discount ? toFixed(-1 * item.discount) : "0.00",
          alignment: "right",
        },
      ],
      [
        {
          text: "ยอดรวมทั้งหมดของการเช่า = (" + THBText(item.total_price) + ")",
          colSpan: 2,
          alignment: "left",
          fillColor: "#F2F2F2",
        },
        "",
        {
          text: toFixed(item.total_price),
          alignment: "right",
          fillColor: "#F2F2F2",
        },
      ],
    ];
  } else {
    receipt = [
      [
        { text: "1", alignment: "center" },
        "ค่าเช่า",
        {
          text: item.rental_price ? toFixed(item.rental_price) : "0.00",
          alignment: "right",
        },
      ],
      [
        { text: "2", alignment: "center" },
        "ค่าค้ำประกัน",
        {
          text: item.guarantee_amount ? toFixed(item.guarantee_amount) : "0.00",
          alignment: "right",
        },
      ],
      [
        { text: "3", alignment: "center" },
        "ค่าอุปกรณ์เสริม",
        { text: toFixed(equipment), alignment: "right" },
      ],
      [
        { text: "4", alignment: "center" },
        "ค่าขนส่ง",
        {
          text: item.delivery_price ? toFixed(item.delivery_price) : "0.00",
          alignment: "right",
        },
      ],
      [
        { text: "5", alignment: "center" },
        "ค่าอื่นๆ",
        {
          text: item.other_price ? toFixed(item.other_price) : "0.00",
          alignment: "right",
        },
      ],
      [
        { text: "6", alignment: "center" },
        "ส่วนลด",
        {
          text: item.discount ? toFixed(item.discount) : "0.00",
          alignment: "right",
        },
      ],
      [
        {
          text: "ยอดรวมทั้งหมดของการเช่า = (" + THBText(item.total_price) + ")",
          colSpan: 2,
          alignment: "left",
          fillColor: "#F2F2F2",
        },
        "",
        {
          text: toFixed(item.total_price),
          alignment: "right",
          fillColor: "#F2F2F2",
        },
      ],
    ];
  }
  var docDefinition = {
    content: [
      {
        columns: [
          {
            text: "S.K. Service Motorcycle For Rent",
            alignment: "left",
            fontSize: 24,
            bold: true,
          },
          {
            text: "ใบเสร็จรับเงิน / Receipt",
            alignment: "right",
            fontSize: 24,
            bold: true,
          },
        ],
      },
      {
        columns: [
          { text: "โทรศัพท์ 098-7532665 , 089-5580007", alignment: "left" },
          {
            text: "เลขที่ใบเสร็จ " + item.payment_number.replaceAll("DP", "RE"),
            alignment: "right",
          },
        ],
      },
      // {
      //   columns: [
      //     { text: "ลูกค้า " + item.full_name, alignment: "left" },
      //     { text: "ประเภทการชำระ " + (item.payment_type === 0 ? "ไม่เลือก" : item.payment_type === 1 ? "เงินสด" : item.payment_type === 2 ? "เงินโอน" : item.payment_type === 3 ? "บัตรเครดิต" : ""), alignment: "right" }
      //   ]
      // },
      { text: "ลูกค้า " + item.full_name, alignment: "left" },
      {
        text:
          "ที่อยู่ " +
          item.address +
          (item.sub_district ? " ต." + item.sub_district : "") +
          (item.district ? " อ." + item.district : "") +
          (item.province ? " จ." + item.province : "") +
          " " +
          item.zip_code,
        alignment: "left",
      },
      " ",
      {
        table: {
          headerRows: 1,
          widths: ["10%", "60%", "30%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center", fillColor: "#F2F2F2" },
              { text: "รายละเอียด", alignment: "left", fillColor: "#F2F2F2" },
              { text: "จำนวนเงิน", alignment: "right", fillColor: "#F2F2F2" },
            ],
            ...receipt,
          ],
        },
      },
      " ",
      {
        columns: [
          {
            width: "50%",
            text:
              "ยอดเงินรับ " +
              toFixed(
                item.total_pay + item.total_pay_transfer + item.total_pay_cradit
              ) +
              " บาท",
            alignment: "left",
          },
          {
            width: "50%",
            text:
              "ยอดเงินทอน " +
              toFixed(
                item.total_pay +
                  item.total_pay_transfer +
                  item.total_pay_cradit -
                  (item.total_price - item.discount + item.spend_wallet)
              ) +
              " บาท",
            alignment: "left",
          },
        ],
      },
      { text: "หมายเหตุ : " + item.remark },
      " ",
      {
        columns: [
          { width: "60%", text: " " },
          {
            width: "40%",
            stack: [
              {
                text: "ลงชื่อ......................................................................",
                alignment: "center",
              },
              { text: "ผู้รับเงิน", alignment: "center" },
              {
                text: "วันที่ " + format_date(new Date(), "dd/mm/yyyy"),
                alignment: "center",
              },
            ],
          },
        ],
      },
      {
        columns: [
          { width: "60%", text: " " },
          {
            width: "40%",
            text: item.admin_return_name,
            alignment: "center",
            margin: [0, -68, 0, 0],
          },
        ],
      },
    ],
    // , alignment: "justify"
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
    pageOrientation: "portrait",
  };

  if (window.location.href.includes(":300")) {
    pdfMake.createPdf(docDefinition).open();
  } else {
    pdfMake.createPdf(docDefinition).download();
  }
}
async function print_receipt_booking(item) {
  var docDefinition = {
    content: [
      {
        columns: [
          {
            text: "S.K. Service Motorcycle For Rent",
            alignment: "left",
            fontSize: 24,
            bold: true,
          },
          {
            text: "ใบเสร็จรับเงิน / Receipt",
            alignment: "right",
            fontSize: 24,
            bold: true,
          },
        ],
      },
      {
        columns: [
          { text: "โทรศัพท์ 098-7532665 , 089-5580007", alignment: "left" },
          { text: "เลขที่ใบเสร็จ " + item.booking_number, alignment: "right" },
        ],
      },
      {
        text: "ลูกค้า " + item.full_name,
        alignment: "left",
      },
      { text: "ที่อยู่", alignment: "left" },
      " ",
      {
        table: {
          headerRows: 1,
          widths: ["10%", "60%", "30%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center", fillColor: "#F2F2F2" },
              { text: "รายละเอียด", alignment: "left", fillColor: "#F2F2F2" },
              { text: "จำนวนเงิน", alignment: "right", fillColor: "#F2F2F2" },
            ],
            [
              { text: "1", alignment: "center" },
              "ค่าเช่า",
              { text: toFixed(item.booking_price), alignment: "right" },
            ],
            [
              { text: "2", alignment: "center" },
              "ค่าปรับ",
              { text: toFixed(item.traffic_ticket_price), alignment: "right" },
            ],
            [
              {
                text:
                  "ยอดรวมทั้งหมดของการเช่า = (" +
                  THBText(item.booking_price + item.traffic_ticket_price) +
                  ")",
                colSpan: 2,
                alignment: "left",
                fillColor: "#F2F2F2",
              },
              "",
              {
                text: toFixed(item.booking_price + item.traffic_ticket_price),
                alignment: "right",
                fillColor: "#F2F2F2",
              },
            ],
          ],
        },
      },
      " ",
      {
        width: "50%",
        text: "ยอดเงินรับ " + toFixed(item.deposit_pay) + " บาท",
        alignment: "left",
      },
      { text: "หมายเหตุ : " },
      " ",
      {
        columns: [
          { width: "60%", text: " " },
          {
            width: "40%",
            stack: [
              {
                text: "ลงชื่อ......................................................................",
                alignment: "center",
              },
              { text: "ผู้รับเงิน", alignment: "center" },
              {
                text: "วันที่ " + format_date(new Date(), "dd/mm/yyyy"),
                alignment: "center",
              },
            ],
          },
        ],
      },
    ],
    // , alignment: "justify"
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
    pageOrientation: "portrait",
  };

  if (window.location.href.includes(":300")) {
    pdfMake.createPdf(docDefinition).open();
  } else {
    pdfMake.createPdf(docDefinition).download();
  }
}

async function print_withdraw(item) {
  var payment = item.payment_list.map((e, index) => {
    return [
      { text: (index + 1).toString(), alignment: "center" },
      e.payment_number.replaceAll("DP", "RT"),
      {
        text:
          e.agent_payment_type === 1
            ? "เงินสด"
            : e.agent_payment_type === 2
            ? "เงินโอน"
            : "",
        alignment: "center",
      },
      { text: toFixed(e.agent_total_pay), alignment: "right" },
    ];
  });
  var docDefinition = {
    content: [
      {
        columns: [
          {
            text: "S.K. Service Motorcycle For Rent",
            alignment: "left",
            fontSize: 24,
            bold: true,
          },
          {
            text: "ใบเบิกเงิน / Withdraw",
            alignment: "right",
            fontSize: 24,
            bold: true,
          },
        ],
      },
      {
        columns: [
          { text: "โทรศัพท์ 098-7532665 , 089-5580007", alignment: "left" },
          { text: "เลขที่ใบเสร็จ " + item.bill_number, alignment: "right" },
        ],
      },
      { text: "ลูกค้า " + item.agent_name, alignment: "left" },
      " ",
      {
        table: {
          headerRows: 1,
          widths: ["10%", "30%", "30%", "30%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center", fillColor: "#F2F2F2" },
              { text: "รายละเอียด", alignment: "left", fillColor: "#F2F2F2" },
              {
                text: "ประเภทการชำระ",
                alignment: "center",
                fillColor: "#F2F2F2",
              },
              { text: "จำนวนเงิน", alignment: "right", fillColor: "#F2F2F2" },
            ],
            ...payment,
            [
              {
                text: "รวม = (" + THBText(item.total_amount) + ")",
                colSpan: 3,
                alignment: "left",
                fillColor: "#F2F2F2",
              },
              "",
              "",
              {
                text: toFixed(item.total_amount),
                alignment: "right",
                fillColor: "#F2F2F2",
              },
            ],
          ],
        },
      },
      " ",
      { text: "หมายเหตุ : " },
      " ",
      {
        columns: [
          {
            width: "50%",
            stack: [
              {
                text: "ลงชื่อ......................................................................",
                alignment: "center",
              },
              { text: "ผู้ส่งเงิน " + item.admin_name, alignment: "center" },
              {
                text: "วันที่ " + format_date(new Date(), "dd/mm/yyyy"),
                alignment: "center",
              },
            ],
          },
          {
            width: "50%",
            stack: [
              {
                text: "ลงชื่อ......................................................................",
                alignment: "center",
              },
              { text: "ผู้รับเงิน", alignment: "center" },
              {
                text: "วันที่ " + format_date(new Date(), "dd/mm/yyyy"),
                alignment: "center",
              },
            ],
          },
        ],
      },
      { image: item.signature, width: 100, margin: [380, -120, 0, 0] },
      { text: item.admin_name, margin: [100, -10, 0, 0] },
      // signature
    ],
    // , alignment: "justify"
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
    pageOrientation: "portrait",
  };

  if (window.location.href.includes(":300")) {
    pdfMake.createPdf(docDefinition).open();
  } else {
    pdfMake.createPdf(docDefinition).download();
  }
}
async function print_scale(state,item) { 
  var line = {
    layout: {
      hLineStyle: function (i, node) {
        return { dash: { length: 1, space: 1 } };
      },
      vLineStyle: function (i, node) {
        return { dash: { length: 1 } };
      },
    },
    margin: [0, 0, 0, 4],
  };
  var docDefinition = {
    content: [ 
          {
            text: "บันทึกเพิ่มเติมต่อท้ายสัญญาเช่ารถจักรยานยนต์",
            alignment: "center",
            fontSize: 24,
            bold: true,
          },  
          " ",  
      { text: "บันทึกข้อตกลงฉบับนี้ทำขึ้นที่ S.K.Service เลขที่ 14/11-13 ซอย 5 (ถนนแก้วนวรัฐ) ตำบลวัดเกต อำเภอเมืองเชียงใหม่ จังหวัด", alignment: "left",margin:[35,0,0,0] },
        {
        table: {
          headerRows: 1,
          widths: ["auto", "*"],
          body: [
            [
              {
                text: "เชียงใหม่ ระหว่าง S.K.Service ซึ่งต่อไปในบันทึกข้อตกลงฉบับนี้จะเรียกว่า “ผู้ให้เช่า” ฝ่ายหนึ่ง กับ",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: item.full_name
                  ? item.full_name
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              }, 
            ], 
          ],
        },
        ...line,
      },
       { text: "ซึ่งต่อไปในบันทึกข้อตกลงฉบับนี้จะเรียกว่า “ผู้เช่า” อีกฝ่ายหนึ่ง โดยที่ ผู้เช่าและผู้ให้เช่าได้ทำสัญญาเช่ารถจักรยานยนต์", alignment: "left" },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "*","auto", "*","auto"],
          body: [
            [
              {
                text: "สัญญาเลขที่",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: item.rental_number
                  ? item.rental_number
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              }, 
              {
                text: "ฉบับลงวันที่",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: item.payment_date
                  ? format_date(item.payment_date)
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              }, 
              {
                text: "ซึ่งต่อไปในบันทึกข้อตกลงฉบับนี้จะเรียกว่า “สัญญาเดิม” ",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
            ], 
          ],
        },
        ...line,
      },
      { text: "ด้วยคู่สัญญาทั้งสองฝ่ายมีความประสงค์จะขยายระยะเวลาการเช่ารถจักรยานยนต์ตามสัญญาเดิมออกไปอีก คู่สัญญาทั้งสองฝ่ายจึง ตกลงทำบันทึกข้อตกลงฉบับนี้ขึ้นโดยมีรายละเอียดดังนี้", alignment: "left" },
      
      " ",
      {
        table: {
          headerRows: 1,
          widths: [35,"auto"],
          body: [
            [{
              text: " ",
              lineHeight: 0.7,
              margin: [-4, 0, 0, 0],
              border: [false, false, false, false],
            },
              {
                text: "คู่สัญญาทั้งสองฝ่ายตกลงขยายระยะเวลาการเช่ารถจักรยานยนต์ตามสัญญาเดิมออกไปอีก",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              }
            ], 
          ],
        },
        ...line,
      },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "*", "auto", "*", "auto"],
          body: [
            [
              {
                text: "ระยะเวลา",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: Math.round(state.days.day / 30),
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              },
              {
                text: "เดือน",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: state.days.day % 30,
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              },
              {
                text: "วัน",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: state.days.hour,
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              },
              {
                text: "ชั่วโมง",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
            ],
          ],
        },
        ...line,
      },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "*","auto", "*"],
          body: [
            [ 
              {
                text: "จากเดิมซึ่งครบกำหนดระยะเวลาเช่าและบริการสิ้นสุดลงในวันที่",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: item.event_extend.return_date
                  ? format_date(item.event_extend.return_date)
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              }, 
              {
                text: "เวลา",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },{
                text: item.event_extend.return_time
                  ? item.event_extend.return_time.slice(0,5)
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              }
            ], 
          ],
        },
        ...line,
      },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "*","auto", "*","auto","*","auto"],
          body: [
            [ 
              {
                text: "เป็นสิ้นสุดลงในวันที่",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: item.event_extend.return_date_new
                  ? format_date(item.event_extend.return_date_new)
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              }, 
              {
                text: "เวลา",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: item.event_extend.return_time_new
                  ? item.event_extend.return_time_new.slice(0,5)
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              },
              {
                text: "รวมเป็นเงิน",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: item.total_price
                  ? toFixed(item.total_price)
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              },
              {
                text: "บาท",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              }
            ], 
          ],
        },
        ...line,
      }, {
        table: {
          headerRows: 1,
          widths: ["auto", "*","auto",200],
          body: [
            [ 
              {
                text: "สถานะการชำระเงิน",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: (item.total_pay !==0 || item.total_pay_cradit!==0 || item.total_pay_transfer!==0 || item.spend_points!==0 || item.spend_wallet!==0)
                  ? "ชำระแล้ว"
                  : "ค้างชำระ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              },  
              {
                text: "",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              }
            ], 
          ],
        },
        ...line,
      },
      " ",
      {text:"ข้าพเจ้าได้อ่านและตกลงตามข้อสัญญาที่กำหนดไว้ในข้อตกลง",margon:[35,0,0,0]},
      " ",
      " ",
      {
        table: {
          headerRows: 1,
          widths: [45, "*", 100, 45, "*", 65],
          body: [
            [
              {
                text: "ลงชื่อ/Sign",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: item.admin_name
                  ? item.admin_name
                  : " ",
                lineHeight: 0.7,
                alignment: "center",
                border: [false, false, false, true],
              },
              {
                text: "ผู้ให้เช่า/Lessor's",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: "ลงชื่อ/Sign",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: " ",
                lineHeight: 0.7,
                alignment: "left",
                border: [false, false, false, true],
              },
              {
                text: "ผู้เช่า/Lessee's",
                lineHeight: 0.7,
                margin: [-4, 0, 0, 0],
                border: [false, false, false, false],
              },
            ], 
          ],
        },
        ...line,
      },  
      { image: state.signature, width: 100, margin: [370, -100, 0, 0] },
    ],
    // , alignment: "justify"
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
    pageOrientation: "portrait",
  };

  if (window.location.href.includes(":300")) {
    pdfMake.createPdf(docDefinition).open();
  } else {
    pdfMake.createPdf(docDefinition).download();
  }
}

async function role(role_name, permission_name) {
  let permission = await getStorage("permission");
  let index = permission.findIndex((e) => e.menu_name === role_name);
  if (index !== -1) {
    return permission[index]["can_" + permission_name];
  }
  return false;
}

let locale = localStorage.getItem("locale")
  ? localStorage.getItem("locale") === "en"
    ? "en"
    : "th"
  : "th";

function status_rent(status, event_type) {
  let text = null;
  switch (status) {
    case 0:
      text = (
        <div
          className="status-rent-0 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 100 }}
        >
          เบิกค่าแนะนำ
        </div>
      );
      break;
    case 1:
      text = (
        <div
          className="status-rent-1 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: event_type === 2 ? 220 : 120 }}
        >
          รอยืนยันการชำระ{event_type === 2 ? " (ขยายสัญญา)" : ""}
        </div>
      );
      break;
    case 2:
      text = (
        <div
          className="status-rent-2 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 65 }}
        >
          รอชำระ
        </div>
      );
      break;
    case 3:
      text = (
        <div
          className="status-rent-3 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 100 }}
        >
          อยู่ระหว่างเช่า
        </div>
      );
      break;
    case 4:
      text = (
        <div
          className="status-rent-4 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 90 }}
        >
          เกินกำหนด
        </div>
      );
      break;
    case 5:
      text = (
        <div
          className="status-rent-5 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 170 }}
        >
          รอตรวจสอบขยายสัญญา
        </div>
      );
      break;
    case 6:
      text = (
        <div
          className="status-rent-6 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 175 }}
        >
          รอยืนยันการชำระ (คืนรถ)
        </div>
      );
      break;
    case 7:
      text = (
        <div
          className="status-rent-7 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 150 }}
        >
          ขยายสัญญาค้างจ่าย
        </div>
      );
      break;
    case 8:
      text = (
        <div
          className="status-rent-8 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 120 }}
        >
          รอคืนรถค้างจ่าย
        </div>
      );
      break;
    case 9:
      text = (
        <div
          className="status-rent-9 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 210 }}
        >
          รอตรวจสอบเปลี่ยนแปลงข้อมูล
        </div>
      );
      break;
    case 10:
      text = (
        <div
          className="status-rent-10 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 120 }}
        >
          คืนรถเรียบร้อย
        </div>
      );
      break;
    case 11:
      text = (
        <div
          className="status-rent-11 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 65 }}
        >
          ยกเลิก
        </div>
      );
      break;
    case 12:
      text = (
        <div
          className="status-rent-12 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 150 }}
        >
          รอมัดจำขยายสัญญา
        </div>
      );
      break;

    default:
      text = null;
      break;
  }
  return text;
}

function status_booking(status) {
  let text = null;
  switch (status) {
    case 0:
      text = (
        <div
          className="status-booking-0 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 70 }}
        >
          ไม่เลือก
        </div>
      );
      break;
    case 1:
      text = (
        <div
          className="status-booking-1 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 100 }}
        >
          รอตรวจสอบ
        </div>
      );
      break;
    case 2:
      text = (
        <div
          className="status-booking-2 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 100 }}
        >
          รอเงินจอง
        </div>
      );
      break;
    case 3:
      text = (
        <div
          className="status-booking-3 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 80 }}
        >
          รออนุมัติ
        </div>
      );
      break;
    case 4:
      text = (
        <div
          className="status-booking-4 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 100 }}
        >
          อนุมัติรอเช่า
        </div>
      );
      break;
    case 5:
      text = (
        <div
          className="status-booking-5 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 65 }}
        >
          ยกเลิก
        </div>
      );
      break;
    case 6:
      text = (
        <div
          className="status-booking-6 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 80 }}
        >
          ค้างชำระ
        </div>
      );
      break;
    case 7:
      text = (
        <div
          className="status-booking-7 rounded px-2 py-1 hpx-30 text-white text-center"
          style={{ width: 100 }}
        >
          มีสัญญาเช่า
        </div>
      );
      break;

    default:
      text = null;
      break;
  }
  return text;
}

function fieldSorter(fields) {
  return function (a, b) {
    return fields
      .map(function (o) {
        var dir = 1;
        if (o[0] === "-") {
          dir = -1;
          o = o.substring(1);
        }
        if (a[o] > b[o]) return dir;
        if (a[o] < b[o]) return -dir;
        return 0;
      })
      .reduce(function firstNonZeroValue(p, n) {
        return p ? p : n;
      }, 0);
  };
} 
export {
  tokens,
  // alert
  success,
  success_url,
  alert,
  alert_url,
  // function
  Logout,
  NumberZero,
  format_date,
  toFixed,
  total,
  validate,
  gen_password,
  float,
  fieldSorter,
  // component
  select_style,
  required,
  DatePickerTH,
  // api
  set_header,
  GET,
  POST,
  PUT,
  DELETE,
  error_message,
  // storage
  removeStorage,
  getStorage,
  locale,
  validateEmail,
  validateTH,
  validateEN,
  validateENNumber,
  getimgBase64,
  role,
  days_between,
  days_between_return_car,
  status_rent,
  status_booking,
  print_paper01,
  print_receipt,
  print_receipt_booking,
  print_withdraw,
  print_scale,
};
